import { render } from "./ClientPart.vue?vue&type=template&id=548735dc"
import script from "./ClientPart.vue?vue&type=script&lang=js"
export * from "./ClientPart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__